import React, { PureComponent } from 'react';
import styled from 'styled-components';

import BannerLayout from '../../layouts/banner';
import LineVertical from '../../../../../containers/assets/onboarding-what-to-expect-line-vertical.svg';
import LineHorizontal from '../../../../../containers/assets/onboarding-what-to-expect-line-horizontal.svg';

const MarketsCustomersBlock1 = styled.div`
  border: 1px solid #D5D9DD;
  border-radius: 8px;
  padding: 20px;
  display: grid;
  grid-template-columns: auto auto auto;
  margin-top: 12px;
  background: #fff;

  > div:first-child {
    grid-column: 3;
    text-align: center;
    margin-bottom: 12px;
  }
  
  > div:nth-child(2) {
    grid-column: 3;
    display: flex;
    align-items: center;
    justify-content: space-around;
    margin-bottom: 7px;
  }
  
  > div:nth-child(3) {
    display: flex;
    align-items: center;
    width: 176px;
  }
  
  > div:nth-child(4) {
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    width: 36px;
  }
`;

const MarketsCustomersLabel = styled.div`
  font-family: 'Mukta Vaani';
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  background: rgba(0, 27, 43, 0.02);
  border-radius: 4px;
  padding: 2px 8px;
  color: rgba(0, 27, 59, 0.6);
  display: inline-block;
`;

const MarketsCustomersHeader = styled.div`
  font-family: 'Mukta Vaani';
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  text-align: center;
  width: 100px;
`;

const MarketsCustomersHeaderRotated = styled.div`
  font-family: 'Mukta Vaani';
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  text-align: center;
  transform: rotate(-90deg) translateX(-2%);

  &:first-child {
    transform: rotate(-90deg) translateX(-15%);
  }
`;

const MarketsCustomersBlock2 = styled.div`
  display: grid;
  grid-template-rows: repeat(2, 1fr);
  grid-template-columns: repeat(2, 1fr);
  row-gap: 20px;
  column-gap: 20px;
  width: fit-content;
  position: relative;

  &:before {
    display: block;
    content: '';
    width: 12px;
    height: 100%;
    background: url(${LineVertical}) no-repeat center center;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
  }
  
  &:after {
    display: block;
    content: '';
    height: 12px;
    width: 100%;
    background: url(${LineHorizontal}) no-repeat center center;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
  }

  > div {
    width: 220px;
    padding: 20px;
    border-radius: 8px;
    text-align: center;
    color: #fff;

    &:first-child {
      background: #F9C151;
      color: rgba(0, 27, 59, 0.94);
    }

    &:nth-child(2) {
      background: #52C5CD;
    }

    &:nth-child(3) {
      background: #EC5E59;
    }

    &:nth-child(4) {
      background: #2A4169;
    }
  }
`;

const MarketsCustomersTitle = styled.h4`
  font-family: 'Mukta Vaani';
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  margin-bottom: 4px; 
`;

const MarketsCustomersText = styled.p`
  font-family: 'Mukta Vaani';
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 20px;
`;

class ProductStrategy extends PureComponent {

  render() {
    const { previousShownErrors } = this.props;

    return (
      <BannerLayout
        section="What to expect next"
        subSection="Product strategy"
        alertText="Product Market Expansion Options"
        previousShownErrors={previousShownErrors}
        paragraph1={(
          <p>Expect competition to heat up in round 2. Therefore, teams will need to be more strategic and vigilant. As you can see below, there are a few product market expansion strategies to consider. <a href="https://www.mindtools.com/pages/article/newTMC_90.htm" target="_blank" rel="noreferrer">Learn More</a></p>
        )}
        paragraph2={(
          <p>Tip: Strategies are best executed when they understand their competitive position. Therefore they should review round 1 Team Report to better understand their competitors’ moves.</p>
        )}
        visual={(
          <MarketsCustomersBlock1>
            <div>
              <MarketsCustomersLabel>
                <p>PRODUCTS</p>
              </MarketsCustomersLabel>
            </div>
            <div>
              <MarketsCustomersHeader>Current</MarketsCustomersHeader>
              <MarketsCustomersHeader>New</MarketsCustomersHeader>
            </div>
            <div>
              <MarketsCustomersLabel>
                <p>MARKETS/ CUSTOMERS</p>
                <p>(auto & mobile)</p>
              </MarketsCustomersLabel>
            </div>

            <div>
              <MarketsCustomersHeaderRotated>Current</MarketsCustomersHeaderRotated>
              <MarketsCustomersHeaderRotated>New</MarketsCustomersHeaderRotated>
            </div>
            <MarketsCustomersBlock2>
              <div>
                <MarketsCustomersTitle>Market Penetration</MarketsCustomersTitle>
                <MarketsCustomersText>Penetrate existing market (auto or mobile)</MarketsCustomersText>
              </div>
              <div>
                <MarketsCustomersTitle>Product Development</MarketsCustomersTitle>
                <MarketsCustomersText>Not Applicable</MarketsCustomersText>
              </div>
              <div>
                <MarketsCustomersTitle>Market Development</MarketsCustomersTitle>
                <MarketsCustomersText>Enter new markets with existing products (auto or mobile)</MarketsCustomersText>
              </div>
              <div>
                <MarketsCustomersTitle>Diversification</MarketsCustomersTitle>
                <MarketsCustomersText>Enter new markets with new products (auto or mobile)</MarketsCustomersText>
              </div>
            </MarketsCustomersBlock2>
          </MarketsCustomersBlock1>
        )
        }
        visualProps={{
          noBorder: true,
          noBackground: true
        }}
      />
    );
  }
}

export default ProductStrategy;


// WEBPACK FOOTER //
// ./src/instructor/components/performance-feedback/pages/what-to-expect-next/product-strategy.js